export default "__VITE_ASSET__DoXj3ui$__"